import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowRight, ShieldCheck } from "lucide-react";
import useGoogleAdsConversion from "../hooks/useGoogleAdsConversion";

const BUNDLE_VALUE = {
    privateer_boarding:      250,
    sovereign_shield:        499,
    website_recommissioning: 499,
};

export default function CatalogThankYou() {
    const [params] = useSearchParams();
    const bundle = params.get("bundle") || "";
    const sessionId = params.get("session_id") || undefined;

    // Stripe redirected the user here only on a successful checkout, so
    // we arm the conversion immediately. Value is mapped per-bundle for
    // accurate ROAS reporting.
    useGoogleAdsConversion({
        event: "catalog",
        armed: !!bundle,
        value: BUNDLE_VALUE[bundle],
        currency: "USD",
        transactionId: sessionId,
    });

    return (
        <div className="min-h-screen flex items-center justify-center px-4 py-20" data-testid="catalog-thankyou">
            <div className="max-w-xl text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[hsl(151_60%_20%)] text-[hsl(151_60%_75%)] mb-5">
                    <CheckCircle2 size={28} />
                </div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[hsl(151_60%_70%)]">Strike Fee Captured</div>
                <h1 className="font-heading text-4xl sm:text-5xl tracking-tighter mt-2">Welcome aboard the Bridge.</h1>
                <p className="text-muted-foreground mt-3">
                    Your <span className="text-foreground font-semibold">{bundle.replace(/_/g, " ") || "Sovereign"}</span> bundle is in. The 60/30/10 covenant has been booked — 60% to your Commander, 30% to Director ops, 10% to the CyberKids Anchor.
                </p>
                <div className="mt-6 rounded-xl border border-[hsl(45_75%_55%/0.4)] bg-[hsl(40_50%_8%/0.5)] p-4 text-xs text-[hsl(45_85%_75%)] flex items-center gap-2 justify-center">
                    <ShieldCheck size={14} /> A Sovereign Operative will reach you within 24h.
                </div>
                <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
                    <Link to="/" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md border border-[hsl(40_40%_30%/0.4)] text-xs uppercase tracking-wider hover:bg-[hsl(151_55%_15%)]">Back to Bridge</Link>
                    <Link to="/login" data-testid="thankyou-login" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-[hsl(40_61%_53%)] text-[hsl(40_20%_10%)] font-semibold text-xs uppercase tracking-wider hover:bg-[hsl(45_75%_62%)]">Board the App <ArrowRight size={12} /></Link>
                </div>
            </div>
        </div>
    );
}
